import { CommonModule } from '@angular/common';
import { ComponentsModule } from 'src/app/components/components.module';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';

import { WelcomePage } from './welcome.page';
import { WelcomePageRoutingModule } from './welcome-routing.module';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, WelcomePageRoutingModule, ComponentsModule],
  declarations: [WelcomePage],
})
export class WelcomePageModule {}
